import React from 'react';
import { IconButton, InputAdornment, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export interface FieldHelpSuffixProps {
  title: React.ReactNode;
  ariaLabel?: string;
  size?: 'small' | 'medium';
  asAdornment?: boolean;
  id?: string;
}

const FieldHelpSuffix = ({
  title,
  ariaLabel,
  size = 'small',
  asAdornment = false,
  id,
}: FieldHelpSuffixProps) => {
  const button = (
    <Tooltip
      title={title}
      enterTouchDelay={50}
      leaveTouchDelay={4000}
    >
      <IconButton
        aria-label={ariaLabel}
        size={size}
        tabIndex={0}
        edge="end"
      >
        <HelpOutlineIcon fontSize={size === 'small' ? 'small' : 'medium'} sx={{color: 'secondary.main'}} />
      </IconButton>
    </Tooltip>
  );

  if (asAdornment) {
    return (
      <InputAdornment position="end" sx={{ ml: 0.5 }}>
        {button}
      </InputAdornment>
    );
  }

  return <>{button}</>;
};

export default FieldHelpSuffix;
